import React from "react";
import { IonContent } from "@ionic/react";
import { useTranslation } from "react-i18next";
import Footer from "components/footer/Footer";
import { useSelector } from "redux/hooks";

const CheckoutErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const region = useSelector((state) => state.location.preferredLocation);

  const checkoutSlug = t("checkout");

  return (
    <IonContent id="ion-content" style={{ "--background": "#fff", "--color": "#333" }}>
      <div style={{ minHeight: "100%", display: "flex", flexDirection: "column", background: "#fff" }}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", padding: "40px 24px" }}>
          <h1 className="optimizedCheckout-headingPrimary">{t("order_confirmation.wspay_payment_failed_heading")}</h1>
          <p style={{ marginTop: 16, marginBottom: 32, fontSize: 14, lineHeight: 1.6 }}>
            {t("order_confirmation.wspay_transaction_failed")}
            <br />
            {t("order_confirmation.wspay_card_not_charged")}
          </p>
          <a
            href={region ? `/${region}/${checkoutSlug}` : `/${checkoutSlug}`}
            data-test="error-continue"
            target="_top"
            style={{ textDecoration: "underline", fontSize: 14 }}
          >
            {t("order.confirmation_continue_shopping")}
          </a>
        </div>
        <Footer />
      </div>
    </IonContent>
  );
};

export default CheckoutErrorPage;
